import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    experimentName: "study3",
    pid:null,
    list:null,
    listname:null,
    prime: null,
    locked: false
  },
  mutations: {
    setPid(state, payload){
      state.pid = payload;
    },
    setList(state, payload){
      state.list = payload;
    },
    setListname(state, payload){
      state.listname = payload;
    },
    setPrime(state, payload){
      state.prime = payload;
    },
    setLocked(state, payload){
      state.locked = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
